import { create } from "zustand";
import type { Lang } from "../lib/i18n";
const KEY="axon-tags.lang";
const read=():Lang=>{ try{return(localStorage.getItem(KEY) as Lang)||"es"}catch{return"es"} };
interface S{lang:Lang;toggleLang:()=>void;setLang:(l:Lang)=>void;}
export const useLangStore=create<S>((set,get)=>({
  lang:read(),
  toggleLang:()=>{
    const next:Lang=get().lang==="es"?"en":"es";
    try{localStorage.setItem(KEY,next)}catch{/**/}
    set({lang:next});
  },
  setLang:(l:Lang)=>{
    try{localStorage.setItem(KEY,l)}catch{/**/}
    set({lang:l});
  }}));
